<template>
  <div
    :style="positionStyle"
    class="interaction-component"
    :class="{ 'color-picker_active': showColorPickerCanva }"
  >
    <v-text-field
      class="center-text bold font-24"
      :value="interaction.nome"
      hide-details
      @change="updateInteractionName"
    ></v-text-field>

    <canvas
      :class="{ active: showColorPickerCanva }"
      ref="canvas"
      @mousemove="getColor"
      @mouseover="setHover"
      @mouseout="unsetHover"
      @click="setColor"
    >
    </canvas>

    <div
      class="interaction"
      ref="interaction"
      :id="interactionId"
      :class="{
        active: dataActive,
        highlight: highlight,
        'color-picker_active': showColorPickerCanva,
      }"
      :style="backgroundStyle"
      @click="click"
      @mouseenter="mouseenter"
      @mouseleave="mouseleave"
      @dragover="dragover"
      @dragleave="dragleave"
      @drop="drop"
    >
      <span class="remove" @click="remove" v-if="dataRemovable">&times;</span>

      <comment-button></comment-button>

      <close></close>

      <app-banner
        v-if="isBanner && interaction"
        :data-mode="dataMode"
        :data-interaction="interaction"
      ></app-banner>

      <app-poll
        v-if="isPoll && interaction"
        :data-mode="dataMode"
        :data-interaction="interaction"
      ></app-poll>

      <app-nps
        v-if="isNps && interaction"
        :data-mode="dataMode"
        :data-interaction="interaction"
      ></app-nps>

      <app-open-field
        v-if="isOpenField && interaction"
        :data-mode="dataMode"
        :data-interaction="interaction"
        @click="click"
      ></app-open-field>

      <app-cupom-view
        v-if="isCupom && interaction"
        :data-mode="dataMode"
        :data-interaction="interaction"
      ></app-cupom-view>

      <app-video
        v-if="isVideo && interaction"
        :data-mode="dataMode"
        :data-interaction="interaction"
      ></app-video>

      <app-interaction-ads
        v-if="isAds && interaction"
        :data-mode="dataMode"
        :data-interaction="interaction"
      ></app-interaction-ads>

      <div
        v-if="(isBanner || isCupom) && designMode && dataActive && !!background"
        :class="`safe-zone ${isCupom ? 'safe-zone_coupon' : ''}`"
      ></div>
    </div>

    <div
      id="color-preview"
      :class="hovering ? 'active' : ''"
      :ref="myUniqueId"
      :style="{ background: colorPreviewColor }"
    ></div>

    <div v-if="loading" class="loading-cover" ref="loadingCover">
      <SyncLoader class="custom-class" color="#e6e6e6" :loading="loading" />
    </div>
  </div>
</template>

<script>
import CommentButton from "@/views/advertising/components/preview/components/CommentButton";
import Close from "./components/Close";
import { SyncLoader } from "@saeris/vue-spinners";
import EventBus from "@packages/event-bus";
import mode from "./mixins/mode";
import uploadsBackground from "@mixins/uploads-background";
import AppBanner from "./components/Banner";
import AppNps from "./components/Nps";
import AppVideo from "./components/Video";
import AppPoll from "./components/Poll";
import AppOpenField from "./components/open-field/OpenField";
import AppCupomView from "./components/CouponView.vue";
import rgbaToCss from "../../../../packages/mixins/rgba-to-css";
import videoCampaign from "@mixins/video-campaign";
import colorPicker from "@mixins/colorPicker";
import AppInteractionAds from "./components/ads/InteractionAds";

export default {
  components: {
    AppBanner,
    AppNps,
    AppPoll,
    AppVideo,
    AppOpenField,
    AppCupomView,
    SyncLoader,
    CommentButton,
    Close,
    AppInteractionAds
  },

  data() {
    return {
      highlight: false,
      entity: "interactions",
      player: undefined,
      done: false,
      videoId: "265111898",
      interactionId: +new Date(),
      videoImage: undefined,
    };
  },

  props: {
    dataInteraction: {
      type: Object,
      required: true,
    },

    dataActive: {
      type: Boolean,
      required: true,
    },

    dataRemovable: {
      type: Boolean,
      required: true,
    },

    dataShowPlaceholder: {
      type: Boolean,
      required: false,
      default: false,
    },

    isDesktop: {
      required: false,
      default: false,
    },
  },

  watch: {
    isVideo(newVal, oldVal) {
      if (oldVal) this.removeBackgroundImage();
    },
    background() {
      if (
        this.isVideo &&
        !this.interaction.isCloudflareVideo &&
        this.interaction.mediaMobile
      ) {
        this.getThumbnailUrl();
      }
    },
    interaction: {
      deep: true,
      handler({ videoMobile }) {
        if (videoMobile) {
          this.videoImage = videoMobile.thumbnailUrl;
        }
      },
    },
  },

  computed: {
    background() {
      return this.isDesktop
        ? this.interaction.mediaDesktop
        : this.interaction.mediaMobile;
    },

    backgroundColorInteraction() {
      return this.interaction.estilo.backgroundColorInteraction.color;
    },

    interaction() {
      return this.dataInteraction;
    },

    interactionStored() {
      return this.$store.state.interactions.list.find(
        (interaction) => interaction.id === this.interaction.id
      );
    },

    backgroundStyle() {
      let styleObj;
      if (this.background || this.videoImage) {
        styleObj = {
          "background-image": this.videoImage
            ? `url(${this.videoImage})`
            : `url(${this.background})`,
        };
      } else {
        styleObj =
          typeof this.backgroundColorInteraction === "object"
            ? {
                "background-color": this.rgbaToCss(
                  this.backgroundColorInteraction
                ),
              }
            : { background: this.backgroundColorInteraction };
      }
      return styleObj;
    },

    positionStyle() {
      return {
        "grid-column-start": this.interaction.posicaoX,
        "grid-row-start": this.interaction.posicaoY,
      };
    },

    isBanner() {
      return this.interaction.tipo === "BANNER";
    },

    isPoll() {
      return this.interaction.tipo === "PESQUISA_OBJETIVA";
    },

    isNps() {
      return this.interaction.tipo === "PESQUISA_NPS";
    },

    isOpenField() {
      return this.interaction.tipo === "OPEN_FIELD";
    },

    isCupom() {
      return this.interaction.tipo === "CODIGO_PROMOCIONAL";
    },

    isPreviewMode() {
      return this.dataMode === "PREVIEW";
    },

    isAds() {
      return this.interaction.tipo === "GOOGLE_PUBLISHER_TAG" || this.interaction.tipo === "VAST";
    },

  },

  methods: {
    updateInteractionName(newName) {
      if (!newName) {
        return EventBus.$emit("show-message", {
          type: "ERROR",
          message: this.$t(
            "message.errorMessages.message.interactionMustHaveName"
          ),
        });
      }
      this.$api.interactions.update({
        interactionId: this.interaction.id,
        advertisingId: this.interaction.campanhaId,
        data: {
          nome: newName,
        },
      });
    },

    click(evt) {
      if (this.linkMode)
        return EventBus.$emit("LINK-INTERACTION", this.interaction.id);

      this.$emit("click");
      evt.stopPropagation();
    },

    mouseenter() {
      if (this.linkMode)
        EventBus.$emit("INTERACTION-MOUSE-ENTER", this.interaction.id);
    },

    mouseleave() {
      if (this.linkMode)
        EventBus.$emit("INTERACTION-MOUSE-LEAVE", this.interaction.id);
    },

    remove(evt) {
      if (this.linkMode) return;

      evt.stopPropagation();
      this.$emit("remove", this.interaction.id);
    },

    drop(evt) {
      if (this.linkMode) return;

      evt.preventDefault();
      this.highlight = false;
      const files = event.dataTransfer.files;

      if (!files || !files[0]) return;

      this.uploadBackground({
        interactionId: this.interaction.id,
        advertisingId: this.interaction.campanhaId,
        file: files[0],
        isMobile: true,
      });
    },

    dragleave() {
      if (this.linkMode) return;

      this.highlight = false;
    },

    dragover(evt) {
      if (this.linkMode) return;

      evt.preventDefault();
      this.highlight = true;
    },

    getThumbnailUrl() {
      if (!this.isYoutube) return;
      const videoId = this.getVideoId(this.interaction.mediaMobile);
      if (!videoId) return;
      this.videoImage = `https://i.ytimg.com/vi/${videoId}/hqdefault.jpg`;
    },

    removeBackgroundImage() {
      this.videoImage = undefined;
    },
  },

  mixins: [uploadsBackground, mode, rgbaToCss, videoCampaign, colorPicker],

  async mounted() {
    this.$store.commit("BIND_INTERACTION_ELEMENT", {
      interaction: this.interaction,
      element: this.$refs.interaction,
    });
    if (this.isVideo) {
      if (this.interaction.mediaMobile) {
        this.getThumbnailUrl();
      } else if (this.interaction.videoMobile) {
        this.videoImage = this.interaction.videoMobile.thumbnailUrl;
      }
    }
  },

  beforeDestroy() {
    this.$store.commit("UNBIND_INTERACTION_ELEMENT", {
      interaction: this.interaction,
    });
  },
};
</script>

<style lang="scss" scoped>
@import "~@variables";

.interaction-component {
  position: relative;

  .loading-cover {
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 100;
    border-radius: 5px;
    background: rgba($color: #000000, $alpha: 0.3);
  }

  canvas {
    display: none;

    cursor: pointer;

    // cursor: url("data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz48IURPQ1RZUEUgc3ZnIFBVQkxJQyAiLS8vVzNDLy9EVEQgU1ZHIDEuMS8vRU4iICJodHRwOi8vd3d3LnczLm9yZy9HcmFwaGljcy9TVkcvMS4xL0RURC9zdmcxMS5kdGQiPjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIiB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCI+PHBhdGggZD0iTTIxIDcuMjRMMTkuMDggOS4xNkwxNC44NCA0LjkyTDE2Ljc2IDNDMTcuOTMgMS44MyAxOS44MyAxLjgzIDIxIDNTMjIuMTcgNi4wNyAyMSA3LjI0TTEwLjk0IDguODJMMTIuMzYgMTAuMjRMMTMgOS42TDE0LjQgMTFMMTMuNzYgMTEuNjRMMTUuMTggMTMuMDZMMTUuODEgMTIuNDNMMTcuMjIgMTMuODVMMTkuMzUgMTEuNzJMMTIuMjggNC42NUwxMC4xNSA2Ljc4TDExLjU3IDguMTlMMTAuOTQgOC44Mk0xOS44NiAyMC4yOUwxOC41OCAyMS41N0wxMi42MyAxNS42MUw4LjEgMjAuMTRMMy41IDIyTDIgMjAuNUwzLjg2IDE1LjlMOC4zOSAxMS4zN0wxLjg2IDQuODVMMy4xNCAzLjU3TDE5Ljg2IDIwLjI5TTExLjIxIDE0LjJMOS44MSAxMi43OUw1LjU2IDE3LjAzTDQuNSAxOS41TDYuOTcgMTguNDRMMTEuMjEgMTQuMloiIC8+PC9zdmc+"),
    //   auto;

    &.active {
      display: block;
    }
  }

  .interaction {
    overflow: visible;
    box-sizing: content-box;
    background-color: $grey-1;

    .player-logo {
      width: 88px;
      height: 48px;
      position: absolute;
      left: 35%;
      top: 50%;
    }

    .remove {
      position: absolute;
      font-size: 32px;
      font-weight: bold;
      cursor: pointer;
      top: 0;
      right: -10px;
      line-height: 0;
      color: $grey-5;
    }

    .safe-zone {
      position: absolute;
      left: 50%;
      top: 65px;
      transform: translateX(-50%);
      border: 2px dashed $grey-3;
      width: calc(100% - 68px);
      height: calc(100% - 160px);

      &.safe-zone_coupon {
        height: calc(100% - 420px);
      }
    }

    &.active {
      margin: -3px;
      border: 3px solid $blue-primary;
    }

    &.highlight {
      margin: -3px;
      border: 3px $blue-primary dashed !important;
    }
  }

  #color-preview {
    display: none;
    position: fixed;
    z-index: 1000;
    width: 10px;
    height: 10px;
    border: 1px solid white;

    &.active {
      display: block;
    }
  }

  &.color-picker_active {
    .interaction {
      display: none;
    }
  }
}
</style>
